import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Llamarlo por su nombre: “Soledad romántica”",
    opening: localizedGenderNode(
      [
      "Hoy no discuto con esto. Le pongo nombre — y dejo de culparme."
    ],
      [
      "Hoy no discuto con esto. Le pongo nombre — y dejo de culparme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “La soledad es una sensación. No es prueba de que haya algo mal en mí.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “La soledad es una sensación. No es prueba de que haya algo mal en mí.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cuándo siento la soledad romántica con más fuerza? (momento/hora/lugar)\n[Escribe aquí]",
      "2. ¿Qué es lo que más me falta dentro de esta sensación? (contacto/pertenencia/alguien que me elija/calidez/conversación íntima)\n[Escribe aquí]",
      "3. ¿Cómo se siente la soledad en mi cuerpo? (pecho/abdomen/garganta/cansancio)\n[Escribe aquí]"
    ],
      [
      "1. ¿Cuándo siento la soledad romántica con más fuerza? (momento/hora/lugar)\n[Escribe aquí]",
      "2. ¿Qué es lo que más me falta dentro de esta sensación? (contacto/pertenencia/alguien que me elija/calidez/conversación íntima)\n[Escribe aquí]",
      "3. ¿Cómo se siente la soledad en mi cuerpo? (pecho/abdomen/garganta/cansancio)\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Hoy di un paso real: nombré la experiencia sin pelear con ella."
    ],
      [
      "Cierre",
      "Hoy di un paso real: nombré la experiencia sin pelear con ella."
    ]
    ),
    action: localizedGenderNode(
      "Cuando aparezca la soledad — una respiración + la frase: “Esto es una emoción. Me quedo conmigo.”",
      "Cuando aparezca la soledad — una respiración + la frase: “Esto es una emoción. Me quedo conmigo.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Separar soledad de “no valgo”",
    opening: localizedGenderNode(
      [
      "Hoy separo la sensación de la conclusión."
    ],
      [
      "Hoy separo la sensación de la conclusión."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “La emoción es fuerte — pero no juzga.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “La emoción es fuerte — pero no juzga.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué frase automática aparece cuando me siento solo/a? (“Nadie me va a querer”, “Estoy atrás”)\n[Escribe aquí]",
      "2. ¿Cuál es el hecho puro? (sin interpretación — dos líneas)\n[Escribe aquí]",
      "3. ¿Qué verdad suave puedo elegir hoy en lugar de la frase automática?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué frase automática aparece cuando me siento solo/a? (“Nadie me va a querer”, “Estoy atrás”)\n[Escribe aquí]",
      "2. ¿Cuál es el hecho puro? (sin interpretación — dos líneas)\n[Escribe aquí]",
      "3. ¿Qué verdad suave puedo elegir hoy en lugar de la frase automática?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No tengo que convertir la soledad en una acusación."
    ],
      [
      "Cierre",
      "No tengo que convertir la soledad en una acusación."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: “Esto es una historia. Vuelvo a los hechos.” + una respiración.",
      "Una vez hoy: “Esto es una historia. Vuelvo a los hechos.” + una respiración."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "El impulso de llenar el vacío rápido (pausa antes de actuar)",
    opening: localizedGenderNode(
      [
      "Hoy construyo una pausa antes de actuar desde el miedo."
    ],
      [
      "Hoy construyo una pausa antes de actuar desde el miedo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “No tengo que llenar el vacío de inmediato.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “No tengo que llenar el vacío de inmediato.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cuál es mi acción impulsiva cuando me siento solo/a? (deslizar pantalla, escribir, cita equivocada, comida, alcohol)\n[Escribe aquí]",
      "2. ¿Qué intento calmar realmente con eso? (miedo, silencio, validación, falta de valor)\n[Escribe aquí]",
      "3. ¿Cuál es una alternativa limpia que me respete hoy?\n[Escribe aquí]"
    ],
      [
      "1. ¿Cuál es mi acción impulsiva cuando me siento solo/a? (deslizar pantalla, escribir, cita equivocada, comida, alcohol)\n[Escribe aquí]",
      "2. ¿Qué intento calmar realmente con eso? (miedo, silencio, validación, falta de valor)\n[Escribe aquí]",
      "3. ¿Cuál es una alternativa limpia que me respete hoy?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Puedo calmar el corazón sin hacerme daño."
    ],
      [
      "Cierre",
      "Puedo calmar el corazón sin hacerme daño."
    ]
    ),
    action: localizedGenderNode(
      "Antes de una acción impulsiva: “pausa de 30 segundos” — una respiración + “me elijo primero”.",
      "Antes de una acción impulsiva: “pausa de 30 segundos” — una respiración + “me elijo primero”."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Lo que la soledad me pide",
    opening: localizedGenderNode(
      [
      "Hoy escucho la petición que hay debajo de la soledad."
    ],
      [
      "Hoy escucho la petición que hay debajo de la soledad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “La soledad es una necesidad que quiere ser escuchada.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “La soledad es una necesidad que quiere ser escuchada.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Si la soledad pudiera hablar — ¿qué pediría?\n[Escribe aquí]",
      "2. ¿Qué necesidad es la más fuerte ahora? (calidez/pertenencia/reconocimiento/contacto/mirada)\n[Escribe aquí]",
      "3. ¿Cómo puedo darme el 10% de esta necesidad hoy sin esperar a otra persona?\n[Escribe aquí]"
    ],
      [
      "1. Si la soledad pudiera hablar — ¿qué pediría?\n[Escribe aquí]",
      "2. ¿Qué necesidad es la más fuerte ahora? (calidez/pertenencia/reconocimiento/contacto/mirada)\n[Escribe aquí]",
      "3. ¿Cómo puedo darme el 10% de esta necesidad hoy sin esperar a otra persona?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Empiezo a darme algo — aunque sea poco."
    ],
      [
      "Cierre",
      "Empiezo a darme algo — aunque sea poco."
    ]
    ),
    action: localizedGenderNode(
      "Un acto pequeño de calidez personal (ducha/manta/música/caminar/comida ordenada).",
      "Un acto pequeño de calidez personal (ducha/manta/música/caminar/comida ordenada)."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "La vergüenza (“¿qué está mal en mí?”)",
    opening: localizedGenderNode(
      [
      "Hoy toco la vergüenza sin dejar que me defina."
    ],
      [
      "Hoy toco la vergüenza sin dejar que me defina."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “La vergüenza quiere que me esconda. Hoy me quedo presente.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “La vergüenza quiere que me esconda. Hoy me quedo presente.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cuál es la frase más vergonzosa que aparece?\n[Escribe aquí]",
      "2. Si un amigo querido dijera esto de sí mismo — ¿qué le diría yo?\n[Escribe aquí]",
      "3. ¿Qué frase suave estoy dispuesto/a a decirme hoy en lugar de la vergüenza?\n[Escribe aquí]"
    ],
      [
      "1. ¿Cuál es la frase más vergonzosa que aparece?\n[Escribe aquí]",
      "2. Si un amigo querido dijera esto de sí mismo — ¿qué le diría yo?\n[Escribe aquí]",
      "3. ¿Qué frase suave estoy dispuesto/a a decirme hoy en lugar de la vergüenza?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La vergüenza no dice la verdad. Dice que me duele."
    ],
      [
      "Cierre",
      "La vergüenza no dice la verdad. Dice que me duele."
    ]
    ),
    action: localizedGenderNode(
      "Mano en el pecho/abdomen (si es cómodo) + una frase suave. Una vez.",
      "Mano en el pecho/abdomen (si es cómodo) + una frase suave. Una vez."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Anhelo de intimidad (no solo de pareja)",
    opening: localizedGenderNode(
      [
      "Hoy reconozco que anhelo intimidad, no necesariamente “a alguien”."
    ],
      [
      "Hoy reconozco que anhelo intimidad, no necesariamente “a alguien”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “La intimidad es cercanía. Tiene muchas formas.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “La intimidad es cercanía. Tiene muchas formas.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué anhelo de verdad? (conversación profunda/contacto/abrazo/ser conocido/a)\n[Escribe aquí]",
      "2. ¿Dónde en mi vida ya hay una gota de intimidad? (amigo/hijos/familia/trabajo/espíritu)\n[Escribe aquí]",
      "3. ¿Cómo creo hoy un pequeño momento de intimidad limpia?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué anhelo de verdad? (conversación profunda/contacto/abrazo/ser conocido/a)\n[Escribe aquí]",
      "2. ¿Dónde en mi vida ya hay una gota de intimidad? (amigo/hijos/familia/trabajo/espíritu)\n[Escribe aquí]",
      "3. ¿Cómo creo hoy un pequeño momento de intimidad limpia?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No espero lo ideal. Empiezo a construir cercanía poco a poco."
    ],
      [
      "Cierre",
      "No espero lo ideal. Empiezo a construir cercanía poco a poco."
    ]
    ),
    action: localizedGenderNode(
      "Una conversación corta con una persona segura — sin explicar, solo estar.",
      "Una conversación corta con una persona segura — sin explicar, solo estar."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Exposición limpia (ACT suave): estar solo/a un minuto",
    opening: localizedGenderNode(
      [
      "Hoy practico quedarme con la soledad un momento — sin escapar."
    ],
      [
      "Hoy practico quedarme con la soledad un momento — sin escapar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Puedo estar con esto un minuto.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Puedo estar con esto un minuto.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cuándo es más difícil estar solo/a?\n[Escribe aquí]",
      "2. Práctica de un minuto: me siento con la sensación un minuto, sin pantalla. ¿Qué pasó en el cuerpo?\n[Escribe aquí]",
      "3. ¿Qué aprendí de la ola? (¿realmente no pasa?)\n[Escribe aquí]"
    ],
      [
      "1. ¿Cuándo es más difícil estar solo/a?\n[Escribe aquí]",
      "2. Práctica de un minuto: me siento con la sensación un minuto, sin pantalla. ¿Qué pasó en el cuerpo?\n[Escribe aquí]",
      "3. ¿Qué aprendí de la ola? (¿realmente no pasa?)\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Me fortalezco no porque la emoción se fue — sino porque me quedé."
    ],
      [
      "Cierre",
      "Me fortalezco no porque la emoción se fue — sino porque me quedé."
    ]
    ),
    action: localizedGenderNode(
      "Solo un minuto. Constancia > fuerza.",
      "Solo un minuto. Constancia > fuerza."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Límites conmigo (no correr a una relación equivocada)",
    opening: localizedGenderNode(
      [
      "Hoy protejo mi corazón de “soluciones rápidas”."
    ],
      [
      "Hoy protejo mi corazón de “soluciones rápidas”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Una relación equivocada no resuelve la soledad — añade dolor.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Una relación equivocada no resuelve la soledad — añade dolor.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué “solución rápida” suelo elegir cuando me siento solo/a?\n[Escribe aquí]",
      "2. ¿Qué precio pago cuando la elijo?\n[Escribe aquí]",
      "3. ¿Qué límite pequeño pondré esta semana para cuidarme?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué “solución rápida” suelo elegir cuando me siento solo/a?\n[Escribe aquí]",
      "2. ¿Qué precio pago cuando la elijo?\n[Escribe aquí]",
      "3. ¿Qué límite pequeño pondré esta semana para cuidarme?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un límite es amor propio en acción."
    ],
      [
      "Cierre",
      "Un límite es amor propio en acción."
    ]
    ),
    action: localizedGenderNode(
      "Elimino un disparador que me lleva a una acción no limpia (app/chat/lugar).",
      "Elimino un disparador que me lleva a una acción no limpia (app/chat/lugar)."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "“Todos están en pareja y yo solo/a” (romper el mito)",
    opening: localizedGenderNode(
      [
      "Hoy dejo de leer la vida de otros desde una sola imagen."
    ],
      [
      "Hoy dejo de leer la vida de otros desde una sola imagen."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “No conozco toda su historia.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “No conozco toda su historia.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué frase de comparación aparece?\n[Escribe aquí]",
      "2. ¿Qué sé realmente y qué solo estoy suponiendo?\n[Escribe aquí]",
      "3. ¿Qué verdad sobre mi camino elijo recordar hoy?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué frase de comparación aparece?\n[Escribe aquí]",
      "2. ¿Qué sé realmente y qué solo estoy suponiendo?\n[Escribe aquí]",
      "3. ¿Qué verdad sobre mi camino elijo recordar hoy?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Mi ritmo no significa que valga menos. Significa que estoy en mi camino."
    ],
      [
      "Cierre",
      "Mi ritmo no significa que valga menos. Significa que estoy en mi camino."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy — paro la comparación: cierro pantalla / respiro / vuelvo a mí.",
      "Una vez hoy — paro la comparación: cierro pantalla / respiro / vuelvo a mí."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Construir una rutina que me sostenga",
    opening: localizedGenderNode(
      [
      "Hoy me doy un ancla — para que el corazón tenga suelo."
    ],
      [
      "Hoy me doy un ancla — para que el corazón tenga suelo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Construyo estabilidad en pasos pequeños.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Construyo estabilidad en pasos pequeños.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿En qué momentos del día ataca más la soledad?\n[Escribe aquí]",
      "2. ¿Qué ancla simple puede entrar ahí? (caminar/comer/ducha/música/orden)\n[Escribe aquí]",
      "3. ¿A qué me comprometo por solo 10 minutos hoy?\n[Escribe aquí]"
    ],
      [
      "1. ¿En qué momentos del día ataca más la soledad?\n[Escribe aquí]",
      "2. ¿Qué ancla simple puede entrar ahí? (caminar/comer/ducha/música/orden)\n[Escribe aquí]",
      "3. ¿A qué me comprometo por solo 10 minutos hoy?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Una rutina pequeña es un abrazo constante."
    ],
      [
      "Cierre",
      "Una rutina pequeña es un abrazo constante."
    ]
    ),
    action: localizedGenderNode(
      "Hago los 10 minutos — y no agrego nada más.",
      "Hago los 10 minutos — y no agrego nada más."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Practicar ser visto/a sin pareja",
    opening: localizedGenderNode(
      [
      "Hoy recupero visibilidad y pertenencia — de forma limpia."
    ],
      [
      "Hoy recupero visibilidad y pertenencia — de forma limpia."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Incluso sin pareja — merezco ser visto/a.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Incluso sin pareja — merezco ser visto/a.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Dónde en mi vida me siento invisible?\n[Escribe aquí]",
      "2. ¿Cuál es una forma saludable de estar en conexión hoy? (conversación/grupo/familia/amigo/comunidad)\n[Escribe aquí]",
      "3. ¿Qué me da miedo al pedir conexión?\n[Escribe aquí]"
    ],
      [
      "1. ¿Dónde en mi vida me siento invisible?\n[Escribe aquí]",
      "2. ¿Cuál es una forma saludable de estar en conexión hoy? (conversación/grupo/familia/amigo/comunidad)\n[Escribe aquí]",
      "3. ¿Qué me da miedo al pedir conexión?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Pedir conexión es valentía, no debilidad."
    ],
      [
      "Cierre",
      "Pedir conexión es valentía, no debilidad."
    ]
    ),
    action: localizedGenderNode(
      "Envío un mensaje limpio a una persona segura: “Me gustaría escucharte.”",
      "Envío un mensaje limpio a una persona segura: “Me gustaría escucharte.”"
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Los bucles nocturnos (soledad en horas silenciosas)",
    opening: localizedGenderNode(
      [
      "Hoy le doy a mi mente un “cierre del día” para descansar."
    ],
      [
      "Hoy le doy a mi mente un “cierre del día” para descansar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Esta noche no tengo que resolver.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Esta noche no tengo que resolver.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cuál es mi bucle nocturno alrededor de la soledad?\n[Escribe aquí]",
      "2. ¿Qué intenta conseguir el bucle para mí? (control/esperanza/validación)\n[Escribe aquí]",
      "3. ¿Qué frase de cierre elijo para la noche?\n[Escribe aquí]",
      "4. ¿Qué ritual de 3 minutos ayudará antes de dormir?\n[Escribe aquí]"
    ],
      [
      "1. ¿Cuál es mi bucle nocturno alrededor de la soledad?\n[Escribe aquí]",
      "2. ¿Qué intenta conseguir el bucle para mí? (control/esperanza/validación)\n[Escribe aquí]",
      "3. ¿Qué frase de cierre elijo para la noche?\n[Escribe aquí]",
      "4. ¿Qué ritual de 3 minutos ayudará antes de dormir?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Una mente cansada cuenta historias fuertes. Esta noche elijo descanso."
    ],
      [
      "Cierre",
      "Una mente cansada cuenta historias fuertes. Esta noche elijo descanso."
    ]
    ),
    action: localizedGenderNode(
      "Antes de dormir: mi frase de cierre + una respiración. Eso es todo.",
      "Antes de dormir: mi frase de cierre + una respiración. Eso es todo."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Convertir la soledad en dirección (lo que construyo ahora)",
    opening: localizedGenderNode(
      [
      "Hoy la soledad se vuelve brújula: lo que de verdad importa."
    ],
      [
      "Hoy la soledad se vuelve brújula: lo que de verdad importa."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Lo que me falta me enseña lo que quiero construir.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Lo que me falta me enseña lo que quiero construir.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué quiero más que nada en mi vida? (relación/hogar/pertenencia/cercanía/compañerismo)\n[Escribe aquí]",
      "2. ¿Qué valor me guiará de ahora en adelante? (respeto/verdad/paz/estabilidad/delicadeza)\n[Escribe aquí]",
      "3. ¿Qué hábito pequeño me acerca a ese valor esta semana?\n[Escribe aquí]",
      "4. ¿Qué me prometo en un día difícil? (una frase)\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué quiero más que nada en mi vida? (relación/hogar/pertenencia/cercanía/compañerismo)\n[Escribe aquí]",
      "2. ¿Qué valor me guiará de ahora en adelante? (respeto/verdad/paz/estabilidad/delicadeza)\n[Escribe aquí]",
      "3. ¿Qué hábito pequeño me acerca a ese valor esta semana?\n[Escribe aquí]",
      "4. ¿Qué me prometo en un día difícil? (una frase)\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No tengo que quedarme en el dolor. Puedo construir una vida."
    ],
      [
      "Cierre",
      "No tengo que quedarme en el dolor. Puedo construir una vida."
    ]
    ),
    action: localizedGenderNode(
      "Planifico una cosa pequeña para la próxima semana que me devuelva futuro (encuentro/grupo/proyecto).",
      "Planifico una cosa pequeña para la próxima semana que me devuelva futuro (encuentro/grupo/proyecto)."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Liberación y cierre (quedarme conmigo)",
    opening: localizedGenderNode(
      [
      "Hoy cierro un capítulo sin borrarlo. Me devuelvo a mí."
    ],
      [
      "Hoy cierro un capítulo sin borrarlo. Me devuelvo a mí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Suelto sin desaparecer.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Suelto sin desaparecer.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Tres cosas que dejo de hacer cuando me siento solo/a (porque me dañan):\n[Escribe aquí]",
      "2. Tres cosas que empiezo a hacer para construir calidez y pertenencia:\n[Escribe aquí]",
      "3. Frase de regreso para días difíciles (corta, clara, en el bolsillo):\n[Escribe aquí]"
    ],
      [
      "1. Tres cosas que dejo de hacer cuando me siento solo/a (porque me dañan):\n[Escribe aquí]",
      "2. Tres cosas que empiezo a hacer para construir calidez y pertenencia:\n[Escribe aquí]",
      "3. Frase de regreso para días difíciles (corta, clara, en el bolsillo):\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final del viaje",
      "No borro la soledad —",
      "dejo de dejar que me defina.",
      "Sigo caminando —",
      "despacio, en silencio, conmigo.",
      "Y eso es fuerza."
    ],
      [
      "Cierre final del viaje",
      "No borro la soledad —",
      "dejo de dejar que me defina.",
      "Sigo caminando —",
      "despacio, en silencio, conmigo.",
      "Y eso es fuerza."
    ]
    ),
    action: localizedGenderNode(
      "Una acción que marque “nuevo capítulo”: caminar en un lugar nuevo / planificar la semana / una conversación valiente.",
      "Una acción que marque “nuevo capítulo”: caminar en un lugar nuevo / planificar la semana / una conversación valiente."
    ),
  },
].map(buildNormalizedDay);

export const romanticLonelinessBlueprintEs = buildNormalizedPilotBlueprint({
  id: "romantic_loneliness_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "romantic_loneliness",
  category: "general",
  journeyName: {
    he: "בדידות רומנטית",
    en: "Romantic Loneliness",
    es: "Soledad Romántica",
  },
  days,
});

export default romanticLonelinessBlueprintEs;
